export default "__VITE_ASSET__5724fb1f__"